// extracted by mini-css-extract-plugin
export default {"general":"InfoScreen_general--n1H","action":"InfoScreen_action--aXI"};